import React, { useEffect, useState } from "react";

function Advert() {
  const images = [
    "https://webview.hijradigital.com/images/images.jpeg",
    "https://webview.hijradigital.com/images/a.jpg",
    "https://webview.hijradigital.com/images/b.jpg",
  ];
  // const images = [
  //   "https://donate.hijradigital.com/images/images.jpeg",
  //   "https://donate.hijradigital.com/images/a.jpg",
  //   "https://donate.hijradigital.com/images/b.jpg",
  // ];

  const imgContainerStyle = {
    width: "100%",
    height: "100vh", // Set height to viewport height
    overflow: "hidden", // Hide overflow to prevent scrolling
    position: "relative", // Ensure absolute positioning is relative to this container
  };

  const imgStyle = {
    width: "100%",
    height: "100%",
  };

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 10000); // 10000 milliseconds = 10 seconds

    // Cleanup the interval when the component is unmounted
    return () => clearInterval(intervalId);
  }, [currentImageIndex, images.length]); // Re-run the effect when the currentImageIndex or images.length changes

  return (
    <div style={imgContainerStyle}>
      <img
        src={images[currentImageIndex]}
        alt={`Slide ${currentImageIndex + 1}`}
        style={imgStyle}
      />
    </div>
  );
}

export default Advert;
